import { axios } from '@/utils/request'

const api = {
    orderList: '/wyhadminapi/order/orderlist',
    orderDetail: '/wyhadminapi/order/orderdetail',
    goodsOptions: '/adminapi/order/goodsOptions',
    businessOptions: '/adminapi/order/businessOptions',
    serviceApplyDo: '/adminapi/order/serviceApplyDo',
    orderSend: '/adminapi/order/orderSend',
    orderReceived: '/adminapi/order/orderReceived',
    expressCompanyOptions: '/adminapi/order/expressCompanyOptions',
    expressEdit: '/adminapi/order/expressEdit',
    priceFix: '/adminapi/order/priceFix',
    goodsRefund: '/adminapi/order/goodsRefund',
    orderRecover: '/adminapi/order/orderRecover',
    businessNoteEdit: '/adminapi/order/businessNoteEdit',
    adminNoteEdit: '/adminapi/order/adminNoteEdit',
    setOrderStar: '/adminapi/order/setOrderStar',
}

export default api
export function getOrderList(parameter) {
    return axios({
        url: api.orderList,
        method: 'get',
        params: parameter
    })
}
export function getOrderDetail(parameter) {
    return axios({
        url: api.orderDetail,
        method: 'get',
        params: parameter
    })
}

export function getGoodsOptions(parameter) {
    return axios({
        url: api.goodsOptions,
        method: 'get',
        params: parameter
    })
}
export function expressCompanyOptions(parameter) {
    return axios({
        url: api.expressCompanyOptions,
        method: 'get',
        params: parameter
    })
}


export function serviceApplyDo(parameter) {
    return axios({
        url: api.serviceApplyDo,
        method: 'post',
        data: parameter
    })
}


export function orderSend(parameter) {
    return axios({
        url: api.orderSend,
        method: 'post',
        data: parameter
    })
}


export function orderReceived(parameter) {
    return axios({
        url: api.orderReceived,
        method: 'post',
        data: parameter
    })
}

export function expressEdit(parameter) {
    return axios({
        url: api.expressEdit,
        method: 'post',
        data: parameter
    })
}

export function priceFix(parameter) {
    return axios({
        url: api.priceFix,
        method: 'post',
        data: parameter
    })
}

export function goodsRefund(parameter) {
    return axios({
        url: api.goodsRefund,
        method: 'post',
        data: parameter
    })
}

export function orderRecover(parameter) {
    return axios({
        url: api.orderRecover,
        method: 'post',
        data: parameter
    })
}

export function adminNoteEdit(parameter) {
    return axios({
        url: api.adminNoteEdit,
        method: 'post',
        data: parameter
    })
}

export function businessNoteEdit(parameter) {
    return axios({
        url: api.businessNoteEdit,
        method: 'post',
        data: parameter
    })
}

export function setOrderStar(parameter) {
    return axios({
        url: api.setOrderStar,
        method: 'post',
        data: parameter
    })
}




export function getBusinessOptions(parameter) {
    return axios({
        url: api.businessOptions,
        method: 'get',
        data: parameter
    })
}